import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Control from '@/helpers/control'
import fetch from '@/helpers/fetch'

import TypeableDatePortal from '@/components/edit/TypeableDatePortal/index.vue'

@Component({
	components: {
		TypeableDatePortal,
	},
})
export default class TableHead extends Vue {
	@Prop() fields

	emitFilters() {
		const data = {}
		this.fields.forEach((field) => {
			if (field.filter) {
				if (
					field.filter.model === null ||
					field.filter.model === undefined
				) {
					field.filter.model = ''
				}

				if (field.unformat) {
					data[field?.fieldName] = field.unformat(field.filter.model)
				} else {
					data[field?.fieldName] = field.filter.model
				}

				if (data[field?.fieldName] === 'true') {
					data[field?.fieldName] = true
				}

				if (data[field?.fieldName] === 'false') {
					data[field?.fieldName] = false
				}
			}
		})

		this.$emit('onFilter', data)
	}

	onFilterDateChange(date, field, type?) {
		if (type) {
			field.filter.model[type] = date
		} else {
			field.filter.model = date
		}

		this.emitFilters()
	}

	control = new Control()

	onInput() {
		const debouncedChange = this.control.debounce(this.emitFilters, 400)
		debouncedChange()
	}

	onSearch(allItems, search) {
		if (typeof search !== 'string') return
		const searchArray = search?.split(' ')

		const result = allItems.filter((item) => {
			const name = removeAccents(item.name.toLowerCase())

			return searchArray.every((string) => {
				return name.includes(removeAccents(string.toLowerCase()))
			})
		})

		return result
	}
}

function removeAccents(str) {
	return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
